module.exports = __webpack_public_path__ + "img/BlinkArt_Sword4_Blue.52b5a466.png";